import { CompanyDeleteModal } from "modules/company/features/company-delete/company-delete-modal";
import { useMyPermissions } from "modules/my-permissions";
import Router from "next/router";
import pages from "pages/_router";
import React, { CSSProperties, FormEvent } from "react";
import { api } from "shared/api";
import { formatDate, Modals } from "shared/lib";
import { Avatar, Button, Entity, Fieldset } from "shared/ui";

export interface ICompanyDeleteForm {
  companySlug: string;

  onSuccess?: () => void;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CompanyDeleteForm = (props: ICompanyDeleteForm) => {
  const permissions = useMyPermissions(props.companySlug);

  const companyList = api.company.useCompanyList();
  const company = api.company.useCompanyGet(props.companySlug);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!company.data) return;

    Modals.open(CompanyDeleteModal, {
      data: company.data,
      onSuccess: async () => {
        await companyList.mutate();
        await Router.replace(pages.dashboard.href);
      },
    });
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId} onSubmit={onSubmit}>
      <Fieldset type="error" disabled={!permissions?.company.general.delete}>
        <Fieldset.Content>
          <Fieldset.Title>Удаление компании</Fieldset.Title>
          <Fieldset.Subtitle>Компания исчезнет, восстановить ее будет нельзя</Fieldset.Subtitle>

          {company.data && (
            <Entity style={{ maxWidth: 450, marginTop: 20 }}>
              <Entity.Field
                avatar={<Avatar {...company.data} size={39} />}
                title={company.data.name}
                description={<>Создана {formatDate(company.data.createdAt)}</>}
                width={200}
              />
            </Entity>
          )}
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status></Fieldset.Footer.Status>
          <Fieldset.Footer.Actions>
            <Button htmlType="submit" size="small" type="error" disabled={!company.data} tabIndex={-1}>
              Удалить
            </Button>
          </Fieldset.Footer.Actions>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

CompanyDeleteForm.defaultProps = {};
